import axios from "axios";
import { getCookieData } from "../Store/GetData";

const instance = axios.create({
  baseURL: process.env.BaseURL,
});
const responseData = () => {
  if (getCookieData("individual_token")) {
    return getCookieData("individual_token");
  } else if (getCookieData("corporate_token")) {
    return getCookieData("corporate_token");
  } else {
    return getCookieData("customer_access_token");
  }
};

instance.interceptors.request.use(
  (request) => {
    if (responseData()) {
      request.headers["Authorization"] = `Bearer ${responseData()}`;
    }
    return request;
  },
  (error) => Promise.reject(error)
);

export default instance;
